const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function fetchAuthenticatedContent({
	dispatch = null,
	endpoint,
	method = "GET",
	body = null,
	headers = null,
	extraParams = {},
	query = {},
}) {
	// console.warn('fetchAuthenticatedContent', dispatch);
	
	const auth = new DrupalOAuth();
	let queryString = "";
	if (query && Object.keys(query).length > 0) {
		queryString += endpoint.includes("?") ? "&" : "?";
		queryString += new URLSearchParams(query).toString();
	}
	const content = await auth.drupalFetch(
		endpoint,
		method,
		body,
		headers,
		extraParams,
		dispatch
	);
	return content;
};
